// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3vDIF","savePackageButton":"ClientWallet_savePackageButton__3jER4"};